import React from 'react';
import './Dashboard.css';

interface DashboardProps {
  onNavigate: (view: string) => void;
}

interface DashboardTile {
  id: string;
  title: string;
  subtitle?: string;
  icon: string;
  color: string;
}

const Dashboard: React.FC<DashboardProps> = ({ onNavigate }) => {
  const tiles: DashboardTile[] = [
    {
      id: 'deworming',
      title: 'Wurmkur',
      subtitle: 'Berechnung',
      icon: '💊',
      color: '#4CAF50'
    },
    {
      id: 'weights',
      title: 'Gewichte',
      subtitle: 'Editor',
      icon: '⚖️',
      color: '#2196F3'
    },
    {
      id: 'editor',
      title: 'Pferde',
      subtitle: 'Editor',
      icon: '🐴',
      color: '#FF9800'
    },
    {
      id: 'contract',
      title: 'Vertrag',
      subtitle: 'Einsteller',
      icon: '📋',
      color: '#9C27B0'
    },
    {
      id: 'boxplan',
      title: 'Boxenplan',
      subtitle: 'Belegung',
      icon: '🏠',
      color: '#795548'
    },
    {
      id: 'phonelist',
      title: 'Telefone',
      subtitle: 'Liste',
      icon: '📞',
      color: '#00BCD4'
    },
    {
      id: 'contacts',
      title: 'Kontakte',
      subtitle: 'Editor',
      icon: '👥',
      color: '#795548'
    },
    {
      id: 'payroll',
      title: 'Stunden',
      subtitle: 'Abrechnung',
      icon: '💰',
      color: '#4CAF50'
    },
    {
      id: 'employees',
      title: 'Mitarbeiter',
      subtitle: 'Verwaltung',
      icon: '👤',
      color: '#607D8B'
    },
    {
      id: 'contract-template',
      title: 'Vorlage',
      subtitle: 'Vertrag',
      icon: '📝',
      color: '#5D4037'
    },
    {
      id: 'contract-documents',
      title: 'Dokumente',
      subtitle: 'Verträge',
      icon: '📂',
      color: '#37474F'
    },
    {
      id: 'prices',
      title: 'Preise',
      subtitle: 'Anpassung',
      icon: '💶',
      color: '#FF5722'
    },
    {
      id: 'students',
      title: 'Reitschüler',
      subtitle: 'Bald verfügbar',
      icon: '🎓',
      color: '#E91E63'
    },
    {
      id: 'impressum',
      title: 'Impressum',
      icon: 'ℹ️',
      color: '#757575'
    },
    {
      id: 'contactinfo',
      title: 'Kontakt',
      icon: '✉️',
      color: '#757575'
    }
  ];

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h2>Willkommen</h2>
        <p>Wählen Sie eine Option</p>
      </div>

      <div className="dashboard-grid">
        {tiles.map((tile) => (
          <div
            key={tile.id}
            className="dashboard-tile"
            onClick={() => onNavigate(tile.id)}
            style={{ '--tile-color': tile.color } as React.CSSProperties}
          >
            <div className="tile-icon">{tile.icon}</div>
            <div className="tile-content">
              <h3>{tile.title}</h3>
              {tile.subtitle && <p>{tile.subtitle}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
